<template>
  <div class="mutil-animation-item">
    <div
      :class="`color-bg ${parseInt(cardResult.star) === 5 ? 'color-bg-ani' : ''}`"
      :style="{ backgroundImage: `url(${colorBg})` }"
    ></div>
    <div class="white-bg"></div>
    <div class="icon-bg" :style="{ backgroundImage: `url(${iconBg})` }"></div>
  </div>
</template>
<script>
export default {
  name: "MutilAnimationItem",
  props: {
    cardResult: { type: Object, required: true }
  },
  computed: {
    colorBg() {
      const star = parseInt(this.cardResult.star);
      if (star === 5) return require("@/assets/zs_imgs/ck-mutil-ani-star5-icon-bg.png");
      if (star === 4) return require("@/assets/zs_imgs/ck-mutil-ani-star4-icon-bg.png");
      return "";
    },
    iconBg() {
      const star = parseInt(this.cardResult.star);
      if (star === 5) return require("@/assets/zs_imgs/ck-mutil-ani-star5-icon.png");
      if (star === 4) return require("@/assets/zs_imgs/ck-mutil-ani-star4-icon.png");
      return require("@/assets/zs_imgs/ck-mutil-ani-star-icon.png");
    }
  }
};
</script>
<style lang="less" scoped>
@keyframes colorframes {
  0% {
    transform: translate(-50%, -50%) scaleY(2);
  }
  100% {
    transform: translate(-50%, -50%) scaleY(1);
  }
}
@keyframes whiteframes {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes iconframes {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.mutil-animation-item {
  position: relative;
  width: 55px;
  height: 100%;
  .color-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 40px;
    height: 100%;
    transform: translate(-50%, -50%);
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  .color-bg-ani {
    animation: colorframes 300ms linear;
    animation-iteration-count: 1;
  }
  .white-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
    background-color: #fff;
    opacity: 0;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    box-shadow: 0 0 6px 6px #fff;
    animation: whiteframes 1000ms linear;
    animation-iteration-count: 1;
  }
  .icon-bg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 40px;
    opacity: 0;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    animation: iconframes 100ms linear;
    animation-iteration-count: 1;
    animation-delay: 100ms;
    animation-fill-mode: forwards;
  }
}
</style>
